(function () {
  'use strict';

  angular.module('app').component('tourCostDetail', tourCostDetail());

  function tourCostDetail() {
    return {
      bindings: {
        tourCosts: '=',
        tour: '<',
        paxRanges: '<',
        seasonSelected: '<',
        priceListSelected: '<',
        provider: '<',
        onTourCostsSaved: '&',
        onTourCostsCanceled: '&',
        getAssociatedProvidersOnSave: '<',
      },
      controller: TourCostDetailComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tour-costs/tour-cost-detail/tour-cost-detail.component.html',
    };
  }

  TourCostDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'TourCostService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function TourCostDetailComponent(config, UtilService, TourCostService, paxRangeService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.selectPaxRange = selectPaxRange;

    vm.saveTourCosts = saveTourCosts;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          selectPaxRange(item);
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          selectPaxRange(paxRangeToSelect);
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.tourCosts.length > 0) {
        // Edit and exists costs
        setSelectedPaxRanges();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.tourCosts[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_COSTS';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_COSTS';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setSelectedPaxRanges() {
      vm.paxRangesSelected = [];

      vm.tourCosts.forEach(function (tourCost) {
        vm.paxRanges.forEach(function (paxRange) {
          if (!checkIfPaxRangeExist(paxRange) && tourCost.pax_range_id === paxRange.id) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });

      if (vm.paxRangesSelected.length === 0) {
        // fix
        vm.paxRangesSelected = [vm.paxRanges[0]];
      }
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }

      return false;
    }

    // Set all costs from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.paxRangesData = [];

      vm.paxRanges.forEach(function (paxRange) {
        paxRange.tour_options = [];

        // loop for the tour options of the selected tour
        vm.tour.tour_options.forEach(function (tourOption) {
          if (tourOption.status === 'active') {
            var option = {
              id: tourOption.id,
              name: tourOption.name,
              status: tourOption.status,
              tour_option_schedules: [],
            };

            // loop for the tour option schedules.
            tourOption.tour_option_schedules.forEach(function (tourOptionSchedule) {
              var schedule = setTourOptionSchedule(tourOption, tourOptionSchedule, paxRange);
              if (tourOptionSchedule.status === 'active') {
                option.tour_option_schedules.push(schedule);
              }
            });

            paxRange.tour_options.push(option);
          }
        });

        vm.paxRangesData.push(paxRange);
      });
    }

    // Gets the Tour options schedule for the selected tour and pax range
    function setTourOptionSchedule(tourOption, tourOptionSchedule, paxRange) {
      var tourCostId;
      var adultCost = '',
        childCost = 0,
        infantCost = 0,
        seniorCost = 0;

      var tourCost;

      // Exist tour costs
      if (vm.tourCosts.length) {
        for (var i = 0; i < vm.tourCosts.length; i++) {
          tourCost = vm.tourCosts[i];

          if (
            tourCost.pax_range_id === paxRange.id &&
            tourCost.tour_option_id === tourOption.id &&
            tourCost.tour_option_schedule_id === tourOptionSchedule.id
          ) {
            tourCostId = tourCost.id;

            adultCost = tourCost.adult_cost;
            childCost = tourCost.child_cost;
            infantCost = tourCost.infant_cost;
            seniorCost = tourCost.senior_cost;
            break;
          }
        }
      }

      var schedule = {
        id: tourOptionSchedule.id,
        departure: tourOptionSchedule.departure,
        status: tourOptionSchedule.status,
        adult_cost: adultCost,
        child_cost: childCost,
        infant_cost: infantCost,
        senior_cost: seniorCost,
        tourCostId: null,
      };

      if (tourCostId) {
        schedule.tourCostId = tourCost.id;
      }

      return schedule;
    }

    function saveTourCosts(isFormValid) {
      if (!isFormValid || vm.tour.tour_options.length === 0) {
        return;
      }

      var tourCosts = [];

      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        var paxRangeSelected = vm.paxRangesSelected[i];

        for (var j = 0; j < vm.paxRangesData.length; j++) {
          var paxRangeData = vm.paxRangesData[j];

          if (paxRangeData.id === paxRangeSelected.id) {
            paxRangeData.tour_options.forEach(function (tourOption) {
              tourOption.tour_option_schedules.forEach(function (tourOptionSchedule) {
                var cost = {
                  adult_cost: tourOptionSchedule.adult_cost || 0,
                  child_cost: tourOptionSchedule.child_cost || 0,
                  infant_cost: tourOptionSchedule.infant_cost || 0,
                  senior_cost: tourOptionSchedule.senior_cost || 0,

                  tour_option_id: tourOption.id,
                  tour_option_schedule_id: tourOptionSchedule.id,
                  pax_range_id: paxRangeSelected.id,
                  id: null,
                };

                if (tourOptionSchedule.tourCostId) {
                  cost.id = tourOptionSchedule.tourCostId;
                }

                tourCosts.push(cost);
              });
            });

            break; // check
          }
        }
      }

      let params = {
        tour_costs: tourCosts,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
        provider_id: vm.provider.id,
        get_associated_providers: null,
      };

      if (vm.getAssociatedProvidersOnSave) {
        params.get_associated_providers = true;
      }

      vm.sendingForm = true;
      TourCostService.saveTourCosts(vm.tour, params, vm.editMode).then(function (data) {
        if (data) {
          let obj = vm.getAssociatedProvidersOnSave ? { dataObj: data.associated_providers } : {};

          vm.onTourCostsSaved(obj);

          setItemOptions(data.tour_costs[0].updated_at);

          vm.tourCosts = data.tour_costs;
          setPaxRangesData();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onTourCostsCanceled();
    }
  }
})();
